import React, {useEffect, useState} from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {getAncestors} from "../../api/organization-unit-functions";
import {httpGet} from "../../api/http-functions";
import {run} from "../../utils/function-util";
import {OrganizationUnitBreadcrumbItem} from "./OrganizationUnitBreadcrumbItem";

export const OrganizationUnitHierarchyBreadcrumbs = ({
    organizationId,
    organizationUnitId,
    fullLevel = true
}: any) => {
    const [ancestors, setAncestors] = useState([]);

    const getAncestorsFn = getAncestors(httpGet);

       useEffect(run(() => getAncestorsFn({organizationId, organizationUnitId, recursive: true}),
        (items: any) => setAncestors(items)), [organizationId, organizationUnitId]);

       return <DumbOrganizationUnitHierarchyBreadcrumbs currentId={parseInt(organizationUnitId)} fullLevel={fullLevel} items={ancestors}/>
};

export const DumbOrganizationUnitHierarchyBreadcrumbs = ({
    currentId,
    fullLevel = true,
    items = []
}: any) => {
    return (
               <Breadcrumbs>
            { items
                .slice(fullLevel ? 0 : -2)
                               .map((item: any) => <OrganizationUnitBreadcrumbItem key={item.id}
                                                             id={item.id}
                                                             name={item.name}
                                                             currentId={currentId}/>)}
        </Breadcrumbs>
    );
}
